import React from "react";

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white pt-16 pb-10 px-6" id="contact">
      <div className="max-w-6xl mx-auto grid md:grid-cols-3 gap-8 mb-12">
        {/* Brand */}
        <div>
          <h3 className="text-2xl font-bold mb-3">BenefitChain</h3>
          <p className="text-gray-400 text-sm">
            A MissionTech Development platform reinventing self-insured benefit delivery through blockchain and AI.
          </p>
        </div>
        {/* Contact Info */}
        <div>
          <h4 className="text-lg font-semibold mb-3">Contact</h4>
          <p className="text-gray-300 text-sm">Email us at:</p>
          <a href="mailto:info@missiontechdev.com" className="text-blue-400 hover:underline text-sm">
            info@missiontechdev.com
          </a>
        </div>
        {/* Navigation */}
        <div>
          <h4 className="text-lg font-semibold mb-3">Navigation</h4>
          <ul className="space-y-2 text-sm text-gray-400">
            <li><a href="#problem" className="hover:text-white">Problem</a></li>
            <li><a href="#solution" className="hover:text-white">Solution</a></li>
            <li><a href="#architecture" className="hover:text-white">Architecture</a></li>
            <li><a href="#stakeholders" className="hover:text-white">Stakeholders</a></li>
            <li><a href="#compliance" className="hover:text-white">Compliance</a></li>
            <li><a href="#pilot" className="hover:text-white">Pilot Program</a></li>
          </ul>
        </div>
      </div>
      <div className="text-center text-xs text-gray-500 border-t border-gray-800 pt-6">
        © {new Date().getFullYear()} BenefitChain. Built by MissionTech Development. All rights reserved.
      </div>
    </footer>
  );
} 